/* OAZAR — produits techniques de personnalisation
   Ces produits restent actifs dans Shopify afin que le configurateur puisse
   utiliser leur prix, mais ils ne doivent jamais être proposés comme de vrais
   produits au client. */
(() => {
  const hiddenClass = 'oazar-technical-product';
  const productCardSelectors = [
    '.oaz-product-card',
    '.ozp-card',
    '.product-card',
    '.product-grid-item',
    '.predictive-search__item',
    '.search-result-item',
    '.op-search-product',
    '.op-cart-line',
    '.op-cart-reco',
    '.cart-items__table-row',
    '.cart-item',
    '[data-cart-line]'
  ].join(',');

  const normalize = (value) => String(value || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

  const technicalTitle = (value) => {
    const v = normalize(value);
    return /^(?:impression|broderie)\s+(?:image|texte|text)(?:\s+(?:small|medium|large|xlarge|xxlarge|xs|s|m|l|xl|xxl))?(?:\s+remise\b.*)?$/.test(v)
      || /^(?:impression|broderie)\s+(?:image|texte|text)\b/.test(v);
  };

  const technicalHandle = (value) => {
    const v = String(value || '').toLowerCase();
    return /^(?:impression|broderie)-(?:image|texte|text)(?:-|$)/.test(v);
  };

  const handleFromUrl = (value) => {
    try {
      return new URL(value || '', window.location.origin).pathname.match(/\/products\/([^/?#]+)/i)?.[1] || '';
    } catch (_) {
      return '';
    }
  };

  const getProductLink = (element) => {
    if (element.matches?.('a[href*="/products/"]')) return element;
    return element.querySelector?.('a[href*="/products/"]') || null;
  };

  const getProductTitle = (element, link) => {
    const title = element.querySelector?.(
      '[data-product-title], .oaz-product-card__title, .product-card__title, .card__heading, .card__title, .predictive-search__item-heading, .op-search-product__title, .op-cart-line__title, .cart-item__title'
    );
    return title?.getAttribute('data-product-title') || title?.textContent || link?.getAttribute('aria-label') || link?.querySelector('img')?.alt || '';
  };

  const isTechnicalElement = (element) => {
    const link = getProductLink(element);
    if (!link && !element.matches('.op-search-product, .op-cart-line, .cart-item, [data-cart-line], .cart-items__table-row')) return false;
    return technicalTitle(getProductTitle(element, link)) || technicalHandle(handleFromUrl(link?.href));
  };

  const applyFilter = (root) => {
    root.querySelectorAll?.(productCardSelectors).forEach((card) => {
      card.classList.toggle(hiddenClass, isTechnicalElement(card));
    });
  };

  const style = document.createElement('style');
  style.textContent = `.${hiddenClass}{display:none!important}`;
  document.head.append(style);

  /* Si quelqu'un ouvre directement un produit technique, on le renvoie vers
     la boutique. Les appels /products/handle.js utilisés par le configurateur
     ne sont pas des navigations de page et ne sont donc pas concernés. */
  const currentHandle = handleFromUrl(window.location.href);
  if (currentHandle && technicalHandle(currentHandle)) {
    window.location.replace('/collections/produits-personnalises');
    return;
  }

  const run = () => applyFilter(document);
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  };

  document.addEventListener('DOMContentLoaded', run);
  if (document.readyState !== 'loading') run();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
